import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Banner } from '@components/home/Banner';
import { ContentTabs } from '@components/home/ContentTabs';
import { WorkCard } from '@components/common/WorkCard';
import { SkeletonCard } from '@components/common/Loading';
import { useGetWorksQuery } from '@services/worksApi';
import { useToast } from '@hooks/useToast';
export default function HomePage() {
    const [activeTab, setActiveTab] = useState('hot');
    const navigate = useNavigate();
    const { success: showSuccess } = useToast();
    // 获取作品数据
    const { data, isLoading, error } = useGetWorksQuery({
        sort: activeTab,
        page: 1,
        pageSize: 12,
    });
    const handleCopyClick = async (workId) => {
        try {
            showSuccess('正在创建同款项目...');
            // 调用拍同款API
            const response = await fetch(`/api/works/${workId}/clone`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response.ok) {
                const result = await response.json();
                showSuccess('同款项目创建成功！');
                // 跳转到剧本编辑页面
                navigate(`/project/${result.projectId}/script`);
            }
            else {
                throw new Error('拍同款失败');
            }
        }
        catch (error) {
            console.error('拍同款错误:', error);
            showError('拍同款失败，请重试');
        }
    };
    return (_jsxs("div", { className: "space-y-8", children: [_jsx(Banner, {}), _jsxs("section", { children: [_jsx(ContentTabs, { activeTab: activeTab, onTabChange: setActiveTab }), isLoading && (_jsx("div", { className: "grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3", children: Array.from({ length: 6 }).map((_, i) => (_jsx(SkeletonCard, {}, i))) })), error && (_jsxs("div", { className: "rounded-lg bg-red-50 p-8 text-center", children: [_jsx("p", { className: "text-red-600", children: "\u52A0\u8F7D\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5" }), _jsx("p", { className: "mt-2 text-sm text-gray-500", children: "\u63D0\u793A\uFF1A\u540E\u7AEFAPI\u672A\u5B9E\u73B0\uFF0C\u8FD9\u662F\u6B63\u5E38\u7684" })] })), data && data.items.length > 0 && (_jsx("div", { className: "grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3", children: data.items.map((work) => (_jsx(WorkCard, { work: work, onCopyClick: handleCopyClick }, work.id))) })), data && data.items.length === 0 && (_jsx("div", { className: "rounded-lg bg-dark-600 border border-gray-800 p-12 text-center", children: _jsx("p", { className: "text-gray-400", children: "\u6682\u65E0\u4F5C\u54C1" }) })), data && data.hasMore && (_jsx("div", { className: "mt-8 text-center", children: _jsx("button", { className: "btn btn-ghost", children: "\u52A0\u8F7D\u66F4\u591A" }) }))] })] }));
}
